import { render } from "./DefaultRetailer.vue?vue&type=template&id=cd769f22&scoped=true"
import script from "../js/default-retailer.js?vue&type=script&lang=js"
export * from "../js/default-retailer.js?vue&type=script&lang=js"

import "./DefaultRetailer.vue?vue&type=style&index=0&id=cd769f22&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd769f22"]])

export default __exports__